import { render, staticRenderFns } from "./operationsupdownme.vue?vue&type=template&id=b8351d56"
import script from "./operationsupdownme.vue?vue&type=script&lang=js"
export * from "./operationsupdownme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports